import {
  IAnalysisConfigBase,
  IInternalBenchmarkAnalysisConfig,
} from '@redux/analysesSlice';
import {
  IProjectAnalysisModel,
  IProjectAnalysisRequestModel,
  AnalysisType,
  AnalysisStatus,
  isAnalysisType,
} from './ProjectAnalysisModelBase';

export class InternalBenchmarkAnalysisModel implements IProjectAnalysisModel {
  id: string;
  name: string;
  type: AnalysisType;
  version: string;
  status: AnalysisStatus;
  created_at: Date;
  updated_at: Date;

  // MARK: - Drivers Specific Properties / Options
  focalPopulation: string;
  internalBenchmark: string;

  constructor(
    id: string,
    name: string,
    type: AnalysisType,
    version: string,
    status: AnalysisStatus,
    created_at: Date,
    updated_at: Date,
    focalPopulation: string,
    internalBenchmark: string
  ) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.version = version;
    this.status = status;
    this.created_at = created_at;
    this.updated_at = updated_at;

    this.focalPopulation = focalPopulation;
    this.internalBenchmark = internalBenchmark;
  }

  static fromAPIResponse(response: object): InternalBenchmarkAnalysisModel {
    // Our response will be an object that will conform to our class structure
    const analysisId = response['Id'];
    const name = response['Name'];
    const type: AnalysisType = AnalysisType.INTERNAL_BENCHMARK;
    const version: string = response['Version'];
    const status: AnalysisStatus = AnalysisStatus[response['Status']]; // TODO: - Fix this issue. Status isn't returned from the server. We need to compute...
    const created_at = new Date(response['CreatedAt'] + "Z");
    const updated_at = new Date(response['UpdatedAt'] + "Z");

    const focalPopulation = response['FocalPopulation'];

    const internalBenchmark = response['InternalBenchmark'];

    return new InternalBenchmarkAnalysisModel(
      analysisId,
      name,
      type,
      version,
      status,
      created_at,
      updated_at,
      focalPopulation,
      internalBenchmark
    );
  }

  toJSON = (): object => {
    return {
      Id: this.id,
      Name: this.name,
      Type: this.type,
      Version: this.version,
      Status: this.status,
      DateAdded: this.created_at,
      DateUpdated: this.updated_at,
      FocalPopulation: this.focalPopulation,
      InternalBenchmark: this.internalBenchmark,
    };
  };

  toConfig = (): IInternalBenchmarkAnalysisConfig => {
    return {
      id: this.id,
      title: this.name,
      analysisType: this.type,
      focalPopulation: this.focalPopulation,
      benchmark: this.internalBenchmark,
    };
  };
}

// MARK: - Interface to make request to API with...
export class InternalBenchmarkAnalysisRequestModel
  implements IProjectAnalysisRequestModel
{
  name: string;
  type: AnalysisType;
  version: string;

  focalPopulation: string;
  internalBenchmark: string;

  constructor(
    name: string,
    version: string,
    focalPopulation: string,
    internalBenchmark: string
  ) {
    this.name = name;
    this.type = AnalysisType.INTERNAL_BENCHMARK;
    this.version = version;
    this.focalPopulation = focalPopulation;
    this.internalBenchmark = internalBenchmark;
  }

  toJSON(): object {
    return {
      Name: this.name,
      Type: this.type,
      Version: this.version,
      FocalPopulation: this.focalPopulation,
      InternalBenchmark: this.internalBenchmark,
    };
  }
}
